import { Component, QueryList, ViewChildren } from '@angular/core';
import {IonicPage, NavController, Platform} from 'ionic-angular';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../services/ebsWebService";
import { Slides } from 'ionic-angular';
declare var $;

@IonicPage({
  name:'Home'
})
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers: [
    EbsWebServiceGlobals,
    EbsWebService
  ],
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class HomePage {
  @ViewChildren(Slides) slides: QueryList<Slides>;
  showContactObject: boolean = false;
  showGridBoxSlider: boolean = false;
  mainContactObjects: any;
  gridBoxSliderObjects: any;
  title: string = "";
  numbers:any;
  sliderBreakpoint:any = 4;
  cordova: boolean = false;
  counterItemsLength: number = 0;

  constructor(public navCtrl: NavController,
    private _ebsWebService: EbsWebService,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals,
    private platform: Platform) {
    if(this.platform.is('ios') || this.platform.is('android')) {
      this.cordova = true;
    }

    this.setScreenSize();
  }

  ionViewWillEnter() {
    this.loadHomeScreenData();
  }

  loadHomeScreenData() {
    this._ebsWebService.postData(this._ebsWebServiceGlobals.getEBSWebServiceMainContentURL(),null).subscribe(res => {
      res.ListItemContent.forEach(element => {
        if (typeof element.GroupTemplateIdentifier != "undefined" && element.GroupTemplateIdentifier != null) {
          if (element.GroupTemplateIdentifier.indexOf("Contact")!=-1) {
            this.showContactObject = true;
            this.mainContactObjects = res.ListItemContent;
          } else if (element.GroupTemplateIdentifier.indexOf("GridBox")!=-1) {
            this.showGridBoxSlider = true;
            this.gridBoxSliderObjects = res.ListItemContent;
            console.log(this.gridBoxSliderObjects);

            // Lukas Bugfix für Slider
            var counterItems = 0
            var counterListRows = 0;
            for (var key in this.gridBoxSliderObjects) {
              counterItems++;
              if(this.gridBoxSliderObjects[key].DataType == "System.List" && this.gridBoxSliderObjects[key].GroupTemplateIdentifier == "GridBoxGroup") {
                counterListRows++;
              }
            }

            this.counterItemsLength = counterItems - counterListRows;
          }
        }
      });

      if (typeof res.Caption != "undefined" &&  res.Caption != null) {
        this.title = res.Caption;
      }

      this._ebsWebService.setBrowserTabTitle(res.MainTitle);
    }); 
  }

  onResize(){
    this.setScreenSize();
  }

  setScreenSize() {
    if (window.innerWidth <= 960) {
      this.sliderBreakpoint = 1;
    } else if (window.innerWidth >= 961 && window.innerWidth <= 1240) {
      this.sliderBreakpoint = 2;
    } else if (window.innerWidth >= 1241 && window.innerWidth <= 1440) {
      this.sliderBreakpoint = 3;
    } else if (window.innerWidth >= 1441) {
      this.sliderBreakpoint = 4;
    }
  }

  next(countid:number) {
    this.slides.toArray()[countid - this.counterItemsLength].slideNext();
    console.log("ButtonID(INDEX): " + countid + " - NichtSliderItems: " + this.counterItemsLength + " = SLIDER ID: " + (countid - this.counterItemsLength))
  }

  prev(countid:number, event) {
    this.slides.toArray()[countid - this.counterItemsLength].slidePrev();
    console.log("ButtonID(INDEX): " + countid + " - NichtSliderItems: " + this.counterItemsLength + " = SLIDER ID: " + (countid - this.counterItemsLength))
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts